// extracted by mini-css-extract-plugin
module.exports = {"logo":"project_logo__r3nU0","description":"project_description__wg9Ik","html":"project_html__SQ4S8","tags":"project_tags__4W5su","links":"project_links__uEfw4"};